export const PaginatorOptions = [
  { value: 10, label: "page-selector-page-label", betweenText: "/" },
  { value: 20, label: "page-selector-page-label", betweenText: "/" },
  { value: 50, label: "page-selector-page-label", betweenText: "/" },
  { value: 100, label: "page-selector-page-label", betweenText: "/" },
];
